import React, { useRef, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import DeleteIcon from "@mui/icons-material/Delete";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import api from "../../axiosInstance";
import { toast } from "react-toastify";

// Table Header and data in Question and answers and Book File.
const columns = [
  { id: "id", label: "ID", minWidth: 170, getValue: (r) => r.id },
  {
    id: "file_name",
    label: "File Name",
    minWidth: 100,
    getValue: (r) => r.file_name,
  },
  {
    id: "unit_id",
    label: "Unit Id",
    minWidth: 170,
    align: "right",
    getValue: (r) => r.unit_id,
  },
];

function QueationsAndAns({ QandA, setBookContent }) {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [open, setOpen] = useState(false);
  const [deletionId, setDeletionId] = useState(null);
  const [showDependencyModal, setShowDependencyModal] = useState(false);
  const [fileDeletionId, setFileDeletionId] = useState(null);
  const [fileNamebackup, setFileNamebackup] = useState(null);

  console.log(QandA);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  // Delete confirmation dialog box
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));
  // Onclick delete icon delete id store in state and open delete dialog box.
  const handleClickOpen = (id, filename) => {
    // setDeletionId(id);
    setFileDeletionId(id);
    setFileNamebackup(filename);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  //   // Delection after click confrim delete the
  //   const handleDelete = async () => {
  //     try {
  //       //  Await the API call to handle errors properly
  //       await api.delete(`/api/v1/bookUnits/${deletionId}`);
  //       setBookContent((prev) => {
  //         console.log(prev["Exam QP"]);

  //         const updatedList = prev["Exam QP"].filter(
  //           (item) => item.id !== Number(deletionId)
  //         );

  //         return {
  //           ...prev,
  //           "Exam QP": updatedList,
  //         };
  //       });

  //       setOpen(false);
  //       setDeletionId(null);
  //       toast.success("Successfully deleted Exam QP!", {
  //         autoClose: 2000,
  //       });
  //     } catch (error) {
  //       console.error("Failed to delete record:", error);

  //       if (error.response && error.response.status === 424) {
  //         toast.error(
  //           "Cannot delete Book unit Without deleting Book unit details",
  //           {
  //             autoClose: 3000,
  //           }
  //         );
  //         setShowDependencyModal(true);
  //         setOpen(false);
  //       } else {
  //         toast.error("An unexpected error occurred while deleting.", {
  //           autoClose: 3000,
  //         });
  //       }
  //     }
  //   };
  //   // Delete the Book unit Details code
  //   const handleDepandencyDelete = async () => {
  //     try {
  //       console.log(deletionId);
  //       // Await the API call to handle errors properly
  //       await api.delete(`/api/v1/bookUnitDetails/${deletionId}`);
  //       setShowDependencyModal(false);
  //       setDeletionId(null);

  //       toast.success("Successfully deleted Exam QP Unit deatils!", {
  //         autoClose: 2000,
  //       });
  //     } catch (error) {
  //       console.error("Failed to delete record:", error);
  //     }
  //   };

  // Backup and delete the files
  const handleBookfilesOpen = async () => {
    try {
      // Step 1: Backup the file before deletion
      //   const backupResponse = await api.post(
      //     `/api/book-files/${fileDeletionId}/backup`,
      //     {},
      //     {
      //       params: { basePath: "/" },
      //       responseType: "blob",
      //     }
      //   );

      //   // Step 2: Download the backup file (optional but recommended)
      //   const blob = new Blob([backupResponse.data]);
      //   const url = window.URL.createObjectURL(blob);

      //   const a = document.createElement("a");
      //   a.href = url;
      //   a.download = fileNamebackup;
      //   document.body.appendChild(a);
      //   a.click();
      //   document.body.removeChild(a);
      //   window.URL.revokeObjectURL(url);
      //   await new Promise((resolve) => setTimeout(resolve, 3000));
      // Step 3: Proceed to delete the unit detail
      await api.delete(`/api/book-files/${fileDeletionId}`);
      setBookContent((prev) =>
        prev.filter((item) => item.id !== Number(deletionId))
      );
      setDeletionId(null);
      setOpen(false);
      toast.success("Successfully and deleted Quesation and answers Files!", {
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Backup or Delete failed:", error);

      if (error.response?.status === 400) {
        toast.error(
          "Backup failed. Cannot delete item without successful backup.",
          {
            autoClose: 3000,
          }
        );
      } else {
        toast.error("An error occurred during backup or deletion.", {
          autoClose: 3000,
        });
      }
    }
  };

  // File download in Book files
  //   const handleDownloadFile = async (downloadId, fileName) => {
  //     try {
  //       const response = await api.post(
  //         `/api/book-files/${downloadId}/backup`,
  //         {}, // no request body
  //         {
  //           params: {
  //             basePath: "/",
  //           },
  //           responseType: "blob",
  //         }
  //       );

  //       const blob = new Blob([response.data]);
  //       const url = window.URL.createObjectURL(blob);

  //       const a = document.createElement("a");
  //       a.href = url;
  //       a.download = fileName; // set the filename for "Save As"
  //       document.body.appendChild(a);
  //       a.click();
  //       console.log(a);

  //       // Cleanup
  //       window.URL.revokeObjectURL(url);
  //       document.body.removeChild(a);
  //     } catch (error) {
  //       console.error("File download failed:", error);
  //     }
  //   };
  return (
    <>
      <Paper sx={{ width: "100%", overflow: "auto" }}>
        <TableContainer sx={{ maxHeight: "70vh" }}>
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    sx={{
                      align: "left",
                      backgroundColor: "#17479e",
                      color: "#ffffff",
                      position: "sticky",
                      top: 0,
                      zIndex: 3,
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
                <TableCell
                  sx={{
                    align: "left",
                    backgroundColor: "#17479e",
                    color: "#ffffff",
                    position: "sticky",
                    top: 0,
                    right: 0,
                    zIndex: 4,
                  }}
                >
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {QandA.length > 0 ? (
                QandA.slice(
                  page * rowsPerPage,
                  page * rowsPerPage + rowsPerPage
                ).map((r, index) => (
                  <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                    {columns.map((column) => {
                      const value = column.getValue
                        ? column.getValue(r)
                        : r[column.id];
                      return (
                        <>
                          <TableCell key={column.id} align={"left"}>
                            {value}
                          </TableCell>
                        </>
                      );
                    })}
                    <TableCell
                      sx={{
                        align: "left",
                        maxWidth: "100px",
                        position: "sticky",
                        right: 0,
                        backgroundColor: "#fff",
                        zIndex: 1,
                      }}
                    >
                      {/* {r.file_name?.length > 0 && (
                        <FileDownloadIcon
                          sx={{
                            color: "#17479e",
                            marginLeft: "10px",
                            cursor: "pointer",
                          }}
                          onClick={() => handleDownloadFile(r.id, r.file_name)}
                        />
                      )} */}
                      <DeleteIcon
                        sx={{
                          color: "#d50000",
                          marginLeft: "10px",
                          cursor: "pointer",
                        }}
                        onClick={() => handleClickOpen(r.id, r.file_name)}
                      />
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={columns.length} align="center">
                    No data available
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={QandA.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          Confirm Delete Units?
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            Do you really want delete these records? <br />
            This process cannot be undone.
          </DialogContentText>
          {(fileNamebackup || "").length !== 0 && (
            <DialogContentText sx={{ fontWeight: 550 }}>
              This file is not backed up. Please take a backup before deleting.
            </DialogContentText>
          )}
        </DialogContent>
        <DialogActions>
          <CancelPresentationIcon
            onClick={handleClose}
            sx={{
              fontSize: "40px",
              cursor: "pointer",
              color: "red",
              marginBottom: "20px",
            }}
          />

          <CheckBoxIcon
            // onClick={() =>
            //   (fileNamebackup || []).length > 0
            //     ? handleBookfilesOpen()
            //     : handleDelete()
            // }
            onClick={() => handleBookfilesOpen()}
            sx={{
              fontSize: "40px",
              color: "green",
              marginRight: "10px",
              marginBottom: "20px",
              cursor: "pointer",
            }}
            autoFocus
          />
        </DialogActions>
      </Dialog>
      {/* <Dialog
        open={showDependencyModal}
        onClose={() => setShowDependencyModal(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Confirm Deletion of Unit Details First ?</DialogTitle>
        <DialogContent>
          <p>
            This unit is linked to unit details and cannot be deleted directly.
          </p>
          <p>Please delete the associated unit details first.</p>
          <p>
            Click the "
            <CheckBoxIcon
              sx={{
                color: "green",
                cursor: "pointer",
              }}
              autoFocus
            />
            " button below to delete the unit details.
          </p>
        </DialogContent>
        <DialogActions>
          <DialogActions>
            <CancelPresentationIcon
              onClick={() => setShowDependencyModal(false)}
              sx={{
                fontSize: "40px",
                cursor: "pointer",
                color: "red",
                marginBottom: "20px",
              }}
            />
            <CheckBoxIcon
              onClick={handleDepandencyDelete}
              sx={{
                fontSize: "40px",
                color: "green",
                marginRight: "10px",
                marginBottom: "20px",
                cursor: "pointer",
              }}
              autoFocus
            />
          </DialogActions>
        </DialogActions>
      </Dialog> */}
    </>
  );
}

export default QueationsAndAns;
